import { QUERIES } from 'styles';
import { arrayFrom } from 'utils/array';

export function FromToArrows() {
  const style = `
    .arrow {
      display: block;
      width: 20px;
      height: 20px;
      border-bottom: 3px solid hsl(20deg, 0%, 75%);
      border-right: 3px solid hsl(20deg, 0%, 75%);
      transform: rotate(45deg);
      animation: arrowPulse__ 1s infinite ease;

      ${QUERIES.PHONE} {
        width: 14px;
        height: 14px;
      }
    }

    .arrow:nth-child(2) {
      animation-delay: 0.1s;
    }

    .arrow:nth-child(3) {
      animation-delay: 0.2s;
    }

    @keyframes arrowPulse__ {
      0% {
        border-color: hsl(20deg, 0%, 50%);
      }
      33% {
        border-color: hsl(20deg, 0%, 65%);
      }
      66% {
        border-color: hsl(20deg, 0%, 75%);
      }
      100% {
        border-color: hsl(20deg, 0%, 90%);
      }
    }
  `;

  return (
    <>
      <div className="-translate-x-[10px] rotate-[270deg]">
        <style>{style}</style>

        {arrayFrom(3).map((_, i) => (
          <span key={i} className="arrow" />
        ))}
      </div>
    </>
  );
}
